import { useEffect } from 'react';
import { unsavedFormChangesActionTypes } from '../../redux/actionTypes';
import { useSelector, useDispatch } from 'react-redux';
import { updateFormChanges, setUnsavedFormStatus } from '../../redux/actions';

const useUnsavedChangesWarning = (isEnabled = true) => {
  const dispatch = useDispatch();
  const unsavedFormChanges = useSelector((state) => state.unsavedFormChanges);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleBeforeUnload = (event) => {
    if (isEnabled && unsavedFormChanges.isChanged) {
      event.preventDefault();
      const result = checkForFormUpdates();
      if (result) {
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
      }
    }
  };

  useEffect(() => {
    if (isEnabled && unsavedFormChanges.isChanged) {
      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, [isEnabled, unsavedFormChanges.isChanged]);

  const updateChangeState = (isChanged, field) => {
    if (
      (isChanged && !unsavedFormChanges.isChanged) ||
      (!isChanged && unsavedFormChanges.isChanged)
    ) {
      dispatch(setUnsavedFormStatus(unsavedFormChangesActionTypes.SET_FORM_STATUS, isChanged));
    }
    if (field && isChanged) {
      const [key] = Object.keys(field);
      const [value] = Object.values(field);
      dispatch(updateFormChanges(unsavedFormChangesActionTypes.SET_FORM_DATA, { key, value }));
    } else if (!isChanged) {
      dispatch(updateFormChanges(unsavedFormChangesActionTypes.RESET_FORM_CHANGES));
    }
  };

  const checkForFormUpdates = () => {
    let isChanged = false;
    for (let key in unsavedFormChanges) {
      if (typeof unsavedFormChanges[key] === 'string' && unsavedFormChanges[key].length > 0) {
        isChanged = true;
      }
    }
    return isChanged;
  };

  return { checkForFormUpdates, unsavedChanges: unsavedFormChanges.isChanged, updateChangeState };
};

export default useUnsavedChangesWarning;
